import React from 'react';

function TabIcon({ name, active }) {
  const c = active ? 'var(--brand)' : 'var(--muted)';
  if (name === 'home') {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 11.5L12 4l8 7.5" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6 10v9a1 1 0 001 1h10a1 1 0 001-1v-9" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 20v-5h4v5" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  if (name === 'ai') {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M21 14a2 2 0 01-2 2H8l-4 4V5a2 2 0 012-2h13a2 2 0 012 2z" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="9" cy="10" r="1.1" fill={c} />
        <circle cx="13" cy="10" r="1.1" fill={c} />
        <circle cx="17" cy="10" r="1.1" fill={c} />
      </svg>
    );
  }
  if (name === 'stores') {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 9l1.5-5h13L20 9" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4 9v1a2.5 2.5 0 005 0 2.5 2.5 0 005 0 2.5 2.5 0 005 0V9" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.5 12.5V20h13v-7.5" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  if (name === 'admin') {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 19v-1.5C4 15.6 6 14 8.5 14h2c2.5 0 4.5 1.6 4.5 3.5V19" stroke={c} strokeWidth="2" strokeLinecap="round" />
        <circle cx="9.5" cy="8.5" r="3" stroke={c} strokeWidth="2" />
        <path d="M16 11l1.6 1.6L21 9.2" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="8.5" stroke={c} strokeWidth="2" />
      <circle cx="12" cy="12" r="4.2" stroke={c} strokeWidth="2" />
      <circle cx="12" cy="12" r="1.3" fill={c} />
    </svg>
  );
}

/**
 * 店舗 (every role, behind a flag) sits after 目標. The last tab depends on role:
 * 管理画面 roles get 管理者 (with the 確認中 count), stylists get コメント
 * (manager comments on their 行動).
 */
export default function TabBar({ active, onChange, showAdmin, showComments, showStores = false, pendingCount = 0 }) {
  const tabs = [
    { key: 'home', icon: 'home', label: 'ホーム' },
    { key: 'ai', icon: 'ai', label: 'AI相談' },
    { key: 'goals', icon: 'goals', label: '目標' },
    ...(showStores ? [{ key: 'stores', icon: 'stores', label: '店舗' }] : []),
    ...(showAdmin ? [{ key: 'admin', icon: 'admin', label: '管理者', badge: pendingCount }] : []),
    ...(!showAdmin && showComments ? [{ key: 'comments', icon: 'ai', label: 'コメント' }] : []),
  ];

  return (
    <nav className="tabbar" aria-label="メインナビゲーション">
      {tabs.map((t) => (
        <button
          key={t.key}
          type="button"
          className={`tab${active === t.key ? ' is-active' : ''}`}
          onClick={() => onChange(t.key)}
          aria-current={active === t.key ? 'page' : undefined}
        >
          <TabIcon name={t.icon} active={active === t.key} />
          {t.badge > 0 && <span className="tab-dot">{t.badge}</span>}
          <span>{t.label}</span>
        </button>
      ))}
    </nav>
  );
}
